var render = function render(){var _vm=this,_c=_vm._self._c;return _c('component-in-worker',[_c('h2',[_vm._v("Sección en construcción")])])
}
var staticRenderFns = []

export { render, staticRenderFns }